export class EnumConstants {
  // Partner Type
  public static partnerType: any = [
    { name: 'Producer', value: 'producer' },
    { name: 'Distributor', value: 'distributor' },
    { name: 'Store', value: 'store' },
    { name: 'Admin', value: 'admin' },
  ];

  // Store Type
  public static storeType: any = [
    { name: 'Buy', value: 'buy' },
    { name: 'Retrieve', value: 'retrieve' },
    { name: 'Buy & Retrieve', value: 'buy&retrieve' },
    { name: 'Delivery', value: 'delivery' },
  ];

  // Status
  public static status: any = [
    { name: 'Enabled', value: 'enabled' },
    { name: 'Disabled', value: 'disabled' },
  ];

  // Recurrence Interval
  public static recurrenceInterval: any = [
    { name: 'Bi-Weekly', value: 'bi-weekly' },
    { name: 'Weekly', value: 'weekly' },
    { name: 'Monthly', value: 'monthly' },
  ];

  // Partner Type
  public static receiptType: any = [
    { name: 'All', value: 'All' },
    { name: 'Processed', value: 'Precessed' },
    { name: 'Unprocessed', value: 'Unprocessed' },
  ];

  // Spin Question Type
  public static spinQuestionType: any = [
    { name: 'Quiz', value: 'quiz' },
    { name: 'Feedback', value: 'feedback' },
  ];

  // Spin Reward Type
  public static spinRewardType: any = [
    { name: 'Points', value: 'points' },
    { name: 'Reward', value: 'reward' },
    { name: 'Multiplier', value: 'multiplier' },
  ];

  // Report Status
  public static reportStatus: any = [
    { name: 'Pending', value: 'pending' },
    { name: 'Valid', value: 'valid' },
    { name: 'Invalid', value: 'invalid' },
  ];

  // Admin Action
  public static adminAction: any = [
    { name: 'Warned', value: 'warned' },
    { name: 'Blocked', value: 'blocked' },
    { name: 'None', value: 'none' },
  ];

  // Report Status For Conversation List
  public static reportStatusForConversationList: any = [
    { name: 'All', value: 'all' },
    { name: 'Pending', value: 'pending' },
  ];

  // Module Name
  public static moduleName = {
    Member: 'Member',
    Subscription: 'Subscription',
    Receipt: 'Receipt',
    Payment: 'Payment',
    Groups: 'Groups',
    SpecialDates: 'Special_Dates',
    IncomeExpense: 'Income_Expense',
    Baptism: 'Baptism',
    Transaction: 'Transaction',
    Confirmation: 'Confirmation',
    Burial: 'Burial',
    Pledge: 'Pledge',
    Ledger: 'Ledger',
    Family: 'Family',
    UserActivity: 'UserActivity',
    Wedding: 'Wedding',
    DailyReading: 'Daily Reading',
    DailyDevotion: 'Daily Devotion',
    DailyVerse: 'Daily Verse',
    Notification: 'Notification',
    PrayerPraise: 'Prayer_Praise',
    Sermon: 'Sermon',
    MissionTrip: 'Mission Trip',
  };

  // Module Code
  public static moduleCode = {
    Subscription: 'SUB',
    Receipt: 'RPT',
    Payment: 'PMT',
    Transaction: 'Transaction',
  };

  // RealTime Events
  public static realTimeEvents = {
    UpdateTransaction: 'UpdateTransaction',
  };

  // Criticality
  public static criticality = {
    VeryHigh: 'very high',
    High: 'high',
    Moderate: 'moderate',
    Low: 'low',
  };

  public static action = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete',
  };

  public static nameFormat = {
    firstNameLastName: 'firstName lastName',
    firstNameDotLastName: 'firstName.lastName',
    firstNameCapsDotLastName: 'firstNameCaps.lastName',
    lastNameFirstName: 'lastName firstName',
    lastNameDotFirstName: 'lastName.firstName',
    lastNameCapsDotFirstName: 'lastNameCaps.firstName',
  };

  public static dateFormat = {
    dayMonthYearSlash: 'DD/MM/YYYY',
    dayMonthYearHyphen: 'DD-MM-YYYY',
    dayMonthYearDot: 'DD.MM.YYYY',
    dateMonthNameYear: 'DD MMM YYYY',
    monthNameDateYear: 'MMM DD, YYYY',
  };

  // Membership Type
  public static membershipType: any = [
    { name: 'Primary', value: 'primary' },
    { name: 'Secondary', value: 'secondary' },
    { name: 'Non Communicant', value: 'non-communicant' },
    { name: 'Deceased', value: 'deceased' },
  ];

  //UserActivity
  public static userActivityList: any = [
    { name: 'Very High', value: 'very high' },
    { name: 'High', value: 'high' },
    { name: 'Moderate', value: 'moderate' },
    { name: 'Low', value: 'low' },
  ];
  // Marital Status
  public static maritalStatus: any = [
    { name: 'Single', value: 'single' },
    { name: 'Married', value: 'married' },
    { name: 'Widowed', value: 'widowed' },
    { name: 'Divorced', value: 'divorced' },
    { name: 'Separated', value: 'separated' },
  ];

  // Gender
  public static gender: any = [
    { name: 'Male', value: 'male' },
    { name: 'Female', value: 'female' },
  ];

  // Title
  public static title: any = [
    { name: 'Mr', value: 'mr' },
    { name: 'Mrs', value: 'mrs' },
    { name: 'Ms', value: 'ms' },
    { name: 'Miss', value: 'miss' },
    { name: 'Master', value: 'master' },
    { name: 'Dr', value: 'dr' },
    { name: 'Rev', value: 'rev' },
  ];

  // Roles
  public static roleList: any = [
    { name: 'Church Head', value: 'church-head' },
    { name: 'Member', value: 'member' },
  ];

  public static nameFormatList: any = [
    { name: 'First Name  Last Name', value: 'firstName lastName' },
    { name: 'First Name. Last Name', value: 'firstName.lastName' },
    { name: 'FIRST NAME. Last Name', value: 'firstNameCaps.lastName' },
    { name: 'Last Name First Name', value: 'lastName firstName' },
    { name: 'Last Name. First Name', value: 'lastName.firstName' },
    { name: 'LAST NAME. First Name', value: 'lastNameCaps.firstName' },
  ];

  public static dateFormatList: any = [
    { name: '25/12/2022', value: 'DD/MM/YYYY' },
    { name: '25-12-2022', value: 'DD-MM-YYYY' },
    { name: '25.12.2022', value: 'DD.MM.YYYY' },
    { name: '25 Dec 2022', value: 'DD MMM YYYY' },
    { name: 'Dec 25, 2022', value: 'MMM DD, YYYY' },
  ];

  public static permissionList: any = [
    { name: 'Auction Admin', value: 'auction-admin' },
    { name: 'Baptism Admin', value: 'baptism-admin' },
    { name: 'Burial Admin', value: 'burial-admin' },
    { name: 'Dashboard', value: 'dashboard' },
    { name: 'Master Admin', value: 'master-admin' },
    { name: 'Member Admin', value: 'member-admin' },
    { name: 'Portal', value: 'portal' },
    { name: 'Portal Admin', value: 'portal-admin' },
    { name: 'Transaction Admin', value: 'transaction-admin' },
  ];

  // Payment type constants
  public static paymentType: any = [
    { name: 'Amazon Pay', value: 'amazon pay' },
    { name: 'Bank Transfer', value: 'bank transfer' },
    { name: 'Cash', value: 'cash' },
    { name: 'Cheque', value: 'cheque' },
    { name: 'DD', value: 'dd' },
    { name: 'Google Pay', value: 'google pay' },
    { name: 'MobiKwik', value: 'mobikwik' },
    { name: 'Others', value: 'others' },
    { name: 'PayTM', value: 'paytm' },
    { name: 'PhonePe', value: 'phonepe' },
  ];

  // Relation to family head
  public static relationToFamilyHead: any = [
    { name: 'Wife', value: 'wife' },
    { name: 'Husband', value: 'husband' },
    { name: 'Father', value: 'father' },
    { name: 'Mother', value: 'mother' },
    { name: 'Son', value: 'son' },
    { name: 'Daughter', value: 'daughter' },
    { name: 'Grandson', value: 'grandson' },
    { name: 'Granddaughter', value: 'granddaughter' },
    { name: 'Brother', value: 'brother' },
    { name: 'Daughter-in-law', value: 'daughter in law' },
    { name: 'Son-in-law', value: 'son in law' },
    { name: 'Mother-in-law', value: 'mother in law' },
    { name: 'Sister-in-law', value: 'sister in law' },
  ];

  // Subscription Type
  public static subscriptionType: any = [
    { name: '3%', value: '3%' },
    { name: '1%', value: '1%' },
    { name: 'Fixed', value: 'fixed' },
  ];

  // Income Type
  public static incomeType: any = [
    { name: 'Monthly Salaried', value: 'monthly salaried' },
    { name: 'Non Regular Income', value: 'non regular income' },
    { name: 'Non Earning', value: 'non earning' },
    { name: 'Pensioner', value: 'pensioner' },
  ];

  // Transaction Type
  public static transactionType: any = [
    { name: 'Payment', value: 'Payment', selected: true },
    { name: 'Receipt', value: 'Receipt', selected: true },
  ];

  // Ledger Group
  public static ledgerGroupList: any = [
    { name: 'Bank Account', value: 'Bank Account' },
    { name: 'Cash in Hand', value: 'Cash in Hand' },
    { name: 'Direct Expense', value: 'Direct Expense' },
    { name: 'Direct Income', value: 'Direct Income' },
    { name: 'Indirect Expense', value: 'Indirect Expense' },
    { name: 'Indirect Income', value: 'Indirect Income' },
  ];

  //Pledge Item Amount Paid Status
  public static statusList: any = [
    { name: 'All', value: 'All' },
    { name: 'Paid', value: 'Paid' },
    { name: 'Unpaid', value: 'Unpaid' },
  ];

  //Notification Channels
  public static notificationChannel: any = [
    { name: 'All', value: 'all' },
    { name: 'Email', value: 'email' },
    { name: 'SMS', value: 'sms' },
    { name: 'Whatsapp', value: 'whatsapp' },
  ];

  //Notification Type
  public static notificationTypeList: any = [
    { name: 'Events', value: 'events' },
    { name: 'Subscription Related', value: 'subscription-related' },
    { name: 'Condolence', value: 'condolence' },
    { name: 'Sermon Updates', value: 'sermon-updates' },
    { name: 'Prayer', value: 'prayer' },
    { name: 'Praise', value: 'praise' },
    { name: 'Mission Trips', value: 'mission-trips' },
    { name: 'Others', value: 'others' },
  ];

  //Notification Send To Type
  public static notificationSendToTypeList: any = [
    { name: 'All', value: 'all' },
    { name: 'Church Head', value: 'church-head' },
    { name: 'Primary', value: 'primary' },
    { name: 'Secondary', value: 'secondary' },
    { name: 'Communicant', value: 'communicant' },
    { name: 'Non communicant', value: 'non-communicant' },
    { name: 'Subscription Payer', value: 'subscription-payer' },
    { name: 'Area Groups', value: 'area-groups' },
    { name: 'Member Groups', value: 'member-groups' },
  ];

  //Prayer Praise Type
  public static prayerPraiseTypeList: any = [
    { name: 'Prayer', value: 'prayer' },
    { name: 'Praise', value: 'praise' },
  ];

  //Prayer Praise Type
  public static prayerPraiseTopicList: any = [
    { name: 'general', value: 'general' },
    { name: 'emotional', value: 'emotional' },
    { name: 'healing', value: 'healing' },
    { name: 'Physical Healing', value: 'physical-healing' },
    { name: 'Relationships', value: 'relationships' },
    { name: 'Spiritual Growth', value: 'spiritual-growth' },
  ];

  public static facilityTypeList: any = [
    { name: 'Church Facility', value: 'church-facility' },
    { name: 'Member Residence', value: 'member-residence' },
    { name: 'Others', value: 'others' },
  ];

  public static sendToTypeList: any = [
    { name: 'All', value: 'all' },
    { name: 'Member Group', value: 'member-group' },
    { name: 'Area Group', value: 'area-group' },
  ];

  public static eventTypeList: any = [
    { name: 'Worship Service', value: 'worship-service', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669122391/ChurchBell/event/worship_service_z7zwkc.jpg' },
    { name: 'Communion Service', value: 'communion-service', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/communion_service_nnxdbl.jpg' },
    { name: 'Bible Study', value: 'bible-study', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/bible_study_nvbyao.jpg' },
    { name: 'Fellowship', value: 'fellowship', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/prayer_meeting_wxzifz.jpg' },
    { name: 'Retreat', value: 'retreat', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614511/ChurchBell/event/retreat_ttiv3m.jpg' },
    { name: 'Wedding', value: 'wedding', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614511/ChurchBell/event/wedding_ytoaym.jpg' },
    { name: 'Engagement', value: 'engagement', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/engagement_mzcvk1.jpg' },
    { name: 'Baby Baptism', value: 'baby-baptism', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/baby_baptism_tau3iz.jpg' },
    { name: 'Choir', value: 'choir', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/choir_vonwiy.jpg' },
    { name: 'Choir Event', value: 'choir-event', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614511/ChurchBell/event/choir_event_mcasqo.jpg' },
    { name: 'Music Concert', value: 'music-concert', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/music_concert_pqm4qe.jpg' },
    { name: 'Lenten', value: 'lenten', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/lenten_xpdb2g.jpg' },
    { name: 'Palm Sunday', value: 'palm-sunday', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669122338/ChurchBell/event/palm_sunday_dx8iyx.jpg' },
    { name: 'Good Friday', value: 'good-friday', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/easter_pof9ys.jpg' },
    { name: 'Easter', value: 'easter', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/easter_pof9ys.jpg' },
    { name: 'Thanks Giving', value: 'thanks-giving', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669121391/ChurchBell/event/thanksgiving_jtq4i2.jpg' },
    { name: 'Confirmation Service', value: 'confirmation-service', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614510/ChurchBell/event/confirmation_service_l3x4jo.jpg' },
    { name: 'Christmas', value: 'christmas', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/christmas_bm72r0.jpg' },
    { name: 'Christmas Event', value: 'christmas-event', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669121390/ChurchBell/event/christmas-1_lirlal.jpg' },
    { name: 'Christmas Children', value: 'christmas-children', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/christmas_children_qx7xo8.jpg' },
    { name: 'Medical', value: 'medical', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669961962/ChurchBell/event/medical_syni06.jpg' },
    { name: 'VBS', value: 'vbs', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1669961962/ChurchBell/event/vbs_qndzd4.jpg' },
    { name: 'Burial', value: 'burial', image: 'https://res.cloudinary.com/kennetjacob/image/upload/v1668614509/ChurchBell/event/burial_oeawu2.jpg' },
  ];

  //Wedding Type
  public static weddingTypeList: any = [
    { name: 'Banns', value: 'banns' },
    { name: 'License', value: 'license' },
  ];

  //Report Name
  public static reportName = {
    afterBanns: 'After_Banns',
    beforeBanns: 'Before_Banns',
    weddingParticular: 'Wedding_Particular',
  };

  //Mission Invited Member Type
  public static invitedMemberTypeList: any = [
    { name: 'All', value: 'all' },
    { name: 'Church Head', value: 'church-head' },
    { name: 'Primary', value: 'primary' },
    { name: 'Secondary', value: 'secondary' },
    { name: 'Communicant', value: 'communicant' },
    { name: 'Non Communicant', value: 'non-communicant' },
    { name: 'Subscription Payer', value: 'subscription-payer' },
    { name: 'Area Groups', value: 'area-groups' },
    { name: 'Member Groups', value: 'member-groups' },
  ];

  //Ads Type
  public static AdsType: any = [
    { name: 'Banner', value: 'banner' },
    { name: 'Spin', value: 'spin' },
    { name: 'News', value: 'news' },
  ];

  //User Type
  public static UserType: any = [
    { name: 'C1', value: 'C1' },
    { name: 'PC1', value: 'PC1' },
    { name: 'C2', value: 'C2' },
    { name: 'PC2', value: 'PC2' },
    { name: 'C3', value: 'C3' },
    { name: 'PC3', value: 'PC3' },
  ];

  //Content Type
  public static ContentType: any = [
    { name: 'Text', value: 'text' },
    { name: 'Image', value: 'image' },
    { name: 'Video', value: 'video' },
    { name: 'Promotional Offer', value: 'promotionalOffer' },
  ];

  //Promotional Offer Type
  public static PromotionalOfferType: any = [
    { name: 'Points', value: 'points' },
    { name: 'Multiplier', value: 'multiplier' },
  ];

  //Reward Type
  public static rewardType: any = [
    { name: 'Basic', value: 'basic' },
    { name: 'Special', value: 'special' },
  ];

  // Spin Reward Type
  public static spinReward1Type: any = [
    { name: 'R1', value: 'R1' },
    { name: 'R2', value: 'R2' },
    { name: 'R3', value: 'R3' },
    { name: 'R4', value: 'R4' },
  ];

  // Gender for TM
  public static genderTM: any = [
    { name: 'All', value: 'all' },
    { name: 'Male', value: 'male' },
    { name: 'Female', value: 'female' },
  ];

  public static deliveryStatusType: any = [
    { name: 'All', value: 'All' },
    { name: 'pending', value: 'pending' },
    { name: 'processing', value: 'processing' },
    { name: 'delivered', value: 'delivered' },
    { name: 'cancelled', value: 'cancelled' },
  ];

  public static rewardDeliveryStatusType: any = [
    { name: 'pending', value: 'pending' },
    { name: 'delivered', value: 'Delivered' },
  ];

  public static deliveryStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Delivered: 'delivered',
    Cancelled: 'cancelled',
  };
}
